export enum Status {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
}
